// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-products-tab {
    animation: fadeIn 0.5s ease-in-out;
}

.tab-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
}

.tab-header h4 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
}

.add-product-btn {
    background-color: #F97316;  
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s;
}

.add-product-btn:hover {
    background-color: #ea580c; 
}

.tab--empty {
    text-align: center;
    padding: 60px 20px;
    background-color: #fff;
    border-radius: 12px;
}

.tab--empty img {
    width: 100px;
    margin-bottom: 20px;
    opacity: 0.7;
}

.tab--empty p {
    font-size: 16px;
    color: #6B7280;
}

.product-actions {
    display: flex;
    gap: 16px;
    align-items: center;
}
 
.product-actions .action-icon {
    width: 20px;
    height: 20px;
}
 
.status-badge { padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 500; text-transform: capitalize; }
.status-active { background-color: #DEF7EC; color: #046C4E; }
.status-inactive { background-color: #FEF3C7; color: #92400E; }
 
.details-tabs {
    border-bottom: 2px solid #F3F4F6;
    margin-bottom: 30px;
}

.details-tabs button {
    background: none;
    border: none;
    padding: 0 5px 15px 5px;
    margin-right: 30px;
    font-size: 16px;
    color: #6B7280;
    cursor: pointer;
    position: relative;
    font-weight: 500;
}

.details-tabs button.active {
    color: #F97316;  
    font-weight: 600;
}

.details-tabs button.active::after {
    content: '';
    position: absolute;
    bottom: -2px;
    left: 0;
    right: 0;
    height: 2px;
    background-color: #F97316;
}
 
.details-content {
    background-color: transparent;
    padding: 0;
    border-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/compoonents/VendorProductsTab/VendorProductsTab.css"],"names":[],"mappings":"AAAA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA,gBAAgB,iBAAiB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB,EAAE,0BAA0B,EAAE;AACvH,iBAAiB,yBAAyB,EAAE,cAAc,EAAE;AAC5D,mBAAmB,yBAAyB,EAAE,cAAc,EAAE;;AAE9D;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,QAAQ;IACR,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,UAAU;IACV,gBAAgB;AACpB","sourcesContent":[".vendor-products-tab {\n    animation: fadeIn 0.5s ease-in-out;\n}\n\n.tab-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n}\n\n.tab-header h4 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: 600;\n}\n\n.add-product-btn {\n    background-color: #F97316;  \n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.2s;\n}\n\n.add-product-btn:hover {\n    background-color: #ea580c; \n}\n\n.tab--empty {\n    text-align: center;\n    padding: 60px 20px;\n    background-color: #fff;\n    border-radius: 12px;\n}\n\n.tab--empty img {\n    width: 100px;\n    margin-bottom: 20px;\n    opacity: 0.7;\n}\n\n.tab--empty p {\n    font-size: 16px;\n    color: #6B7280;\n}\n\n.product-actions {\n    display: flex;\n    gap: 16px;\n    align-items: center;\n}\n \n.product-actions .action-icon {\n    width: 20px;\n    height: 20px;\n}\n \n.status-badge { padding: 4px 12px; border-radius: 16px; font-size: 12px; font-weight: 500; text-transform: capitalize; }\n.status-active { background-color: #DEF7EC; color: #046C4E; }\n.status-inactive { background-color: #FEF3C7; color: #92400E; }\n \n.details-tabs {\n    border-bottom: 2px solid #F3F4F6;\n    margin-bottom: 30px;\n}\n\n.details-tabs button {\n    background: none;\n    border: none;\n    padding: 0 5px 15px 5px;\n    margin-right: 30px;\n    font-size: 16px;\n    color: #6B7280;\n    cursor: pointer;\n    position: relative;\n    font-weight: 500;\n}\n\n.details-tabs button.active {\n    color: #F97316;  \n    font-weight: 600;\n}\n\n.details-tabs button.active::after {\n    content: '';\n    position: absolute;\n    bottom: -2px;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background-color: #F97316;\n}\n \n.details-content {\n    background-color: transparent;\n    padding: 0;\n    border-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
